{
  "tabs": {
    "chat": "Zance",
    "reminders": "Tunatarwa",
    "calendar": "Kalandar",
    "settings": "Saituna"
  },
  "common": {
    "cancel": "Soke",
    "save": "Ajiye",
    "confirm": "Tabbatar",
    "delete": "Goge",
    "back": "Baya",
    "close": "Rufe",
    "edit": "Gyara",
    "search": "Bincika",
    "all": "Duka",
    "loading": "Ana lodawa...",
    "error": "An samu matsala",
    "notFound": "Ba a samu ba",
    "tryAgain": "Don Allah a sake gwadawa",
    "retry": "Sake gwadawa",
    "undo": "Soke",
    "pullToRefresh": "Ja don sabuntawa",
    "justNow": "yanzu haka"
  },
  "auth": {
    "welcome": "Barka da zuwa FishMemory",
    "tagline": "Mataimakin tunatarwar WhatsApp dinka, yanzu a aljeka.",
    "subtitle": "Mataimakin tunatarwar WhatsApp dinka, yanzu a aljeka.",
    "phoneLabel": "Lambar WhatsApp dinka",
    "phoneHint": "Za mu aika da lambar tabbatarwa ta WhatsApp",
    "invalidPhone": "Don Allah shigar da lambar waya mai inganci",
    "continue": "Ci gaba",
    "enterPhone": "Shigar da lambar WhatsApp dinka",
    "phonePlaceholder": "Lambar waya",
    "sendCode": "Aika Lamba",
    "verifyTitle": "Tabbatar da lambarka",
    "otpSentTo": "An aika lambar lambobi 6 zuwa {{phone}} ta WhatsApp",
    "enterFullCode": "Don Allah shigar da lambobi 6 duka",
    "invalidOtp": "Lambar ba daidai ba ce. Don Allah a sake gwadawa.",
    "otpFailed": "An kasa aika lambar. Sake gwadawa.",
    "otpResent": "An sake aika lambar",
    "resendIn": "Sake aika cikin {{seconds}}s",
    "resendCode": "Sake aika lambar",
    "enterOtp": "Shigar da lambar da aka aika zuwa WhatsApp dinka",
    "verify": "Tabbatar",
    "resend": "Sake aika lambar",
    "wrongNumber": "Lamba ba daidai ba?",
    "backToPhone": "Komawa waya",
    "editPhone": "Gyara lambar waya",
    "error": "Kuskure",
    "setupTitle": "Bari mu saita abubuwa",
    "setupSubtitle": "Kuna iya canza waɗannan daga baya a Saituna",
    "namePlaceholder": "Sunan ka",
    "letsGo": "Kammala saitawa",
    "skipForNow": "Wucewa yanzu"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Rubuta saƙo...",
    "inputPlaceholder": "Rubuta saƙo...",
    "typing": "FishMemory na rubutu...",
    "online": "Kan layi",
    "connecting": "Haɗawa...",
    "reconnecting": "Sake haɗawa...",
    "offline": "Ba a layi",
    "empty": "Fara hira",
    "emptyHint": "Ƙirƙiri tunatarwa, duba jadawalin ka, ko nemi taimako.",
    "emptyAction": "Aika misalin tunatarwa",
    "actions": "Ayyukan hira",
    "keep": "Ajiye saƙonni",
    "clearTitle": "Share hira",
    "clearConfirm": "Goge duk saƙonni daga wannan na'ura? Ba za a iya dawo da shi ba.",
    "clear": "Share hira",
    "optionSelected": "An zaɓa: {{label}}",
    "sendingSelection": "Ana aikawa...",
    "connectionLost": "Sake haɗawa..."
  },
  "reminders": {
    "title": "Tunatarwata",
    "active": "Aiki",
    "today": "Yau",
    "thisWeek": "Wannan mako",
    "history": "Tarihi",
    "items": "abubuwa",
    "emptyTitle": "Babu tunatarwa tukuna",
    "emptySubtitle": "Ƙirƙiri ɗaya daga hira zai bayyana anan.",
    "emptyAction": "Bude hira",
    "filterActive": "Aiki",
    "filterToday": "Yau",
    "filterWeek": "Wannan mako",
    "filterHistory": "Tarihi",
    "emptyState": "Babu tunatarwa tukuna. Fara hira!",
    "swipeDone": "An gama",
    "swipeSnooze": "Dakatar",
    "swipeDelete": "Goge",
    "search": "Bincika tunatarwa...",
    "upcoming": "Mai zuwa",
    "completed": "An kammala",
    "overdue": "Wanda ya wuce lokaci",
    "tomorrow": "Gobe",
    "synced": "An daidaita {{value}}",
    "swipeHint": "Yi swip akan tunatarwa don ƙarin ayyuka",
    "noResults": "Babu tunatarwa da suka dace da bincikenka",
    "noResultsHint": "Gwada wani kalma ko share binciken",
    "deleteAllFailed": "An kasa gogewa duk tunatarwa"
  },
  "calendar": {
    "title": "Kalandar",
    "today": "Yau",
    "tomorrow": "Gobe",
    "completed": "an gama",
    "noEvents": "Babu abubuwan da aka tsara",
    "noEventsSubtitle": "Zaɓi kwanan wata don ganin tunatarwa da abubuwan kalandar.",
    "googleEvent": "Kalandar Google",
    "legendActive": "Aiki",
    "legendRecurring": "Maimaici",
    "legendDone": "An gama",
    "legendGoogle": "Google",
    "previousMonth": "Watan da ya gabata",
    "nextMonth": "Watan gaba",
    "previousYear": "Shekarar da ta gabata",
    "nextYear": "Shekarar gaba",
    "goToToday": "Je zuwa yau",
    "all": "Duka",
    "active": "Aiki",
    "done": "An gama",
    "paused": "An dakatar"
  },
  "settings": {
    "title": "Saituna",
    "profile": "Bayanan martaba",
    "name": "Sunan Nuna",
    "enterName": "Shigar da sunanka",
    "language": "Harshe",
    "uiLanguage": "Harshe na app",
    "uiLanguageHelp": "Yana canza UI na app, alamomin kalandar, da tsarin shafi a wannan na'ura kawai.",
    "serverLanguage": "Harshe na hira",
    "serverLanguageHelp": "Yana canza harshen da uwar garken ke amfani da shi don amsoshin hira da saƙonnin tunatarwa na asusunka.",
    "timezone": "Yanayin lokaci",
    "currentTimezone": "Yanayin lokaci na yanzu",
    "timezoneHelp": "Dukkan lokutan tunatarwa ana nuna su ne ta amfani da wannan yanayin lokaci.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Ajiye yanayin lokaci",
    "timezoneSaved": "An sabunta yanayin lokaci",
    "detect": "Gano",
    "detectFailed": "Ba a iya gano yanayin lokaci ba",
    "autoDetect": "Gano ta atomatik daga GPS",
    "notifications": "Sanarwa",
    "notificationsHelp": "Tunatarwar bin diddigi suna sarrafa faɗakarwa masu maimaitawa bayan an isar da tunatarwa. Izinin sanarwa na na'ura ana sarrafa su a saitunan wayarka.",
    "pushEnabled": "Sanarwar turawa",
    "autoDoneOnFire": "Alama ta atomatik lokacin da aka kunna",
    "autoDoneOnFireDesc": "Idan an kashe, tunatarwa suna ci gaba da aiki har sai ka alama an gama su.",
    "googleCalendar": "Kalandar Google",
    "google": "Kalandar Google",
    "googleConnected": "An haɗa",
    "googleDisconnected": "Ba a haɗa ba",
    "googleConnectedHelp": "Sabbin tunatarwa za a iya daidaita su zuwa kalandarka ta atomatik.",
    "googleDisconnectedHelp": "Haɗa Kalandar Google don kiyaye daidaito tsakanin tunatarwa da abubuwan kalandar.",
    "googleConnectFailed": "An kasa haɗa Kalandar Google",
    "connected": "An haɗa",
    "disconnected": "Ba a haɗa ba",
    "connect": "Haɗa",
    "disconnect": "Cire haɗi",
    "autoSync": "Daidaita sabbin tunatarwa ta atomatik",
    "autosync": "Daidaita sabbin tunatarwa ta atomatik",
    "subscription": "Biyan kuɗi",
    "trialUsed": "Gwaji: {{used}}/{{total}} an yi amfani",
    "trialStatus": "Gwaji yana nan",
    "activeStatus": "Biyan kuɗi yana aiki",
    "expiredStatus": "Biyan kuɗi ya ƙare",
    "unsubscribedStatus": "Ba a yi biyan kuɗi ba",
    "about": "Game da",
    "version": "Sigar",
    "logout": "Fita",
    "logoutTitle": "Fita",
    "logoutConfirm": "Ka tabbata kana son fita?",
    "noName": "Babu suna an saita",
    "serverConnection": "Haɗin uwar garke",
    "serverUrl": "URL na uwar garke",
    "serverEdit": "Gyara",
    "saveReconnect": "Ajiye kuma sake haɗawa",
    "resetDefault": "Sake saitin tsoho",
    "invalidServerUrlTitle": "URL na uwar garke ba daidai ba ne",
    "invalidServerUrlMessage": "Shigar da ingantaccen URL na uwar garke http ko https, misali https://example.com",
    "uiLanguageChangeFailed": "An kasa canza harshen app. Don Allah a sake gwadawa.",
    "serverLanguageChangeFailed": "An kasa canza harshen hira. Don Allah a sake gwadawa.",
    "timezoneChangeFailed": "An kasa canza yanayin lokaci. Don Allah a sake gwadawa.",
    "autoSyncChangeFailed": "An kasa sabunta daidaita ta atomatik. Don Allah a sake gwadawa.",
    "nameChangeFailed": "An kasa sabunta sunan nuna. Don Allah a sake gwadawa.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Cikakkun bayanan tunatarwa",
    "editTime": "Gyara lokaci",
    "rename": "Sake suna",
    "snooze": "Dakatar",
    "snooze15": "Dakatar na minti 15",
    "pause": "Dakatar",
    "pauseReminder": "Dakatar da tunatarwa",
    "resume": "Ci gaba",
    "resumeReminder": "Ci gaba da tunatarwa",
    "skip": "Tsallake na gaba",
    "skipOccurrence": "Tsallake wannan lokaci",
    "syncGoogle": "Daidaita zuwa Google",
    "delete": "Goge",
    "deleteTitle": "Goge Tunatarwa",
    "deleteConfirm": "Wannan tunatarwar za a goge ta dindindin.",
    "deleteRecurringTitle": "Goge Tunatarwar Maimaici",
    "deleteRecurringMessage": "Kana son tsallake wannan lokaci ko goge duk jerin?",
    "deleteThisOccurrence": "Tsallake Wannan Lokaci",
    "deleteEntireSeries": "Goge Duk Jerin",
    "done": "An gama",
    "markDone": "Alama a matsayin an gama",
    "undo": "Mayar",
    "undoPrompt": "Kana bukatar ta kasance aiki? Mayar yanzu.",
    "recurring": "Maimaici",
    "nextRun": "Gudu na gaba",
    "oneTime": "Sau ɗaya",
    "pending": "Na jiran aiki",
    "sent": "An aika",
    "paused": "An dakatar",
    "active": "Aiki",
    "snoozed": "An dakatar na ɗan lokaci",
    "localTime": "An nuna a lokacin gida",
    "recurrence": "Maimaici",
    "created": "An ƙirƙira",
    "tags": "Alamomi",
    "fireCount": "Yawan lokutan da aka kunna",
    "actions": "Ayyuka",
    "none": "Babu",
    "snoozeFailed": "An kasa dakatar da tunatarwa",
    "pauseFailed": "An kasa dakatar da tunatarwa",
    "resumeFailed": "An kasa ci gaba da tunatarwa",
    "skipFailed": "An kasa tsallake tunatarwa",
    "doneFailed": "An kasa alama tunatarwa a matsayin an gama",
    "undoFailed": "An kasa dawo da matsayin tunatarwa",
    "deleteFailed": "An kasa gogewa tunatarwa",
    "rescheduleTitle": "Sake tsara lokaci?",
    "rescheduleMsg": "Wannan tunatarwar ta wuce lokaci. Kana son sake tsara ta?",
    "reschedule15": "Cikin minti 15",
    "reschedule60": "Cikin awa 1",
    "keepOverdue": "Bar shi haka"
  },
  "onboarding": {
    "slide1Title": "Barka da zuwa FishMemory",
    "slide1Sub": "Mataimakin tunatarwa na kanka — mai amfani da WhatsApp kuma an gina shi don aljeka.",
    "slide2Title": "Yi Hira Kamar Yadda Kake",
    "slide2Sub": "Rubuta tunatarwa kamar yadda kake tunani: \"Tunatar da ni in kira uwa gobe da karfe 3 na yamma\" — mu muna kula da sauran.",
    "slide3Title": "Kada Ka Manta Komai",
    "slide3Sub": "Samu faɗakarwa akan lokaci, tsara tare da alamomi, kuma kasance a saman duk abin da ya dace.",
    "getStarted": "Fara",
    "next": "Gaba",
    "firstReminderTitle": "Ƙirƙiri tunatarwa ta farko!",
    "firstReminderHint": "Gwada rubuta wani abu kamar:",
    "firstReminderExample": "Tunatar da ni in sha ruwa gobe da karfe 9 na safe",
    "gotIt": "Na gane!",
    "notifRationaleTitle": "Kasance akan lokaci",
    "notifRationaleBody": "FishMemory na buƙatar sanarwa don tunatar da kai akan lokaci. Za ka samu faɗakarwa ne kawai don tunatarwar da ka ƙirƙira.",
    "notifRationaleAllow": "Bada Izinin Sanarwa",
    "notifRationaleLater": "Wataƙila daga baya",
    "swipeHint": "Yi swip zuwa dama don ayyuka masu sauri →",
    "calendarDragHint": "Ja don faɗaɗa ↕"
  }
}
